module.exports = __webpack_public_path__ + "img/hand.dfa66e68.png";